export const colors = {
  blue: '#348EE9',
  mainDark: '#222222',
  mainGray: '#8B8E93',
  gray: '#D9D9D9',
  lightGray: '#EFEFEF',
  darkGray: '#363636',
  white: '#FFFFFF',
};
